const SmartMonitor = {
    'Title': 'Smart Monitor',
    'Products': [{
            "id": 1,
            "heading": "Transducer & Isolator",
            "top_desc": " Measure, record and visualize electrical network parameters ",
            "image": '../assets/images/transducer.webp',
            "bottom_desc": " Isolation Interface | Signal Changeover | Power Transducer | Voltage Transducer",
            "features_heading": "Salient Features",
            "salient_features": [
                "Measured parameters can be programmed to generate equivalent output signals ",
                "Override selection for desired value and range",
                "Isolation between input to output or output to output",
                "Quick response time of 300ms in display and communication",
                " On field configurable Input and Output parameters",
                "User friendly interface to support remote monitoring and communication",
            ],
            "app_heading": "Applications",
            "app_list": ["Easy to install and is field configurable by the user ",
                " Output signal is transferable over a long range",
                "  Textile and manufacturing industry",
                " Process Manufacturing/OEM’s",
            ]
        },
        {
            "id": 2,
            "heading": "Digital Panel Meter",
            "top_desc": "Basic parameters measured precisely",
            "image": '../assets/images/digitalpanel.webp',
            "bottom_desc": " Ammeter | Volt meter | VAF Meter | Hz Meter | Frequency MeterDC Meter | RPM & MPM | Transducer Output ",
            "features_heading": "Salient Features",
            "salient_features": [
                "Inbuilt Selector Switch",
                "High resolution reading with autoscaling",
                "Suitable for industrial panels, gen-sets, solar, pump control panels, etc.",
                "Optional RS485 for data collection",
                "  Optional easy interface to PLC through modbus protocol ",
            ],
            "app_heading": "Applications",
            "app_list": [
                "AC & DC Measurement ",
                " Equipment Monitoring",
                "  Genset, Solar and UPS applications",
                " In control panel to measure different electrical loads"
            ],
        },
        {
            "id": 3,
            "heading": " Multifunction Meter",
            "top_desc": "Simultaneous measurement of various electrical parameters",
            "image": '../assets/images/multifunctionmeter.webp',
            "bottom_desc": " Basic | Power | Energy | Load Manager Digital Output | Pulse Output ",
            "features_heading": "Salient Features",
            "salient_features": [
                "Easy navigation",
                "Event recording with time stamp (all basic & power parameters)",
                "Unbalance load and voltage with calculated neutral current.",
                "Dynamic communication",
                "  Optional digital output for all basic and power parameters ",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Monitoring Electrical Parameters ",
                "Control / protection",
                "  In control panel to measure different electrical loads",
                " Generator & control panels",
            ]
        },
        {
            "id": 4,
            "heading": " Branch Circuit Monitor",
            "top_desc": "Compact device to enroute multiple channels",
            "image": '../assets/images/branchcircuitmonitor.webp',
            "bottom_desc": " Multi-channel load manager | Power distribution unit ",
            "prod_id": "branchcircuitmonitor",
            "features_heading": "Salient Features",
            "salient_features": [
                "Multiple branches of load can be monitored together",
                " Faster communication through RS485 port (Modbus protocol)d",
                "Accuracy Class 1.0 as per IEC 62053-21 & Class 0.5 as per IEC 62053-22 Standards",
                "Displays more than 25 parameters",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Remote reading and control",
                "Building management system",
                " In control panel to measure different electrical loads",
                "  Ideal for billing in apartments/commercial complexes",
            ]
        },
        {
            "id": 5,
            "heading": " Generator Monitoring Unit",
            "top_desc": "Generator monitoring device with dual display",
            "image": '../assets/images/generatormonitoringunit.webp',
            "bottom_desc": " Counter & LED Display | Pulse Output ",
            "prod_id": "generalmoitoringunit",
            "features_heading": "Salient Features",
            "salient_features": [
                "Avoids the requirement of 2 different meters (energy and VAF in one)",
                " Reduces the cost and simplify wiring",
                "High resolution reading with auto scaling in LED",
                "Energy consumption in counter even if CT is reversed",
            ],
            "app_heading": "Applications",
            "app_list": [
                " Easy configuration of Gen-set Controllers",
                "Monitor health & Readiness",
                " Remote operation & control",
                "  Multiple alarms & notifications"
            ]
        },
        {
            "id": 6,
            "heading": " Dual Source Energy Meter",
            "top_desc": "Collecting data from two different sources of energy",
            "image": '../assets/images/dualsourceenergymeter.webp',
            "bottom_desc": " Multifunction meter | Dual source measurement ",
            "prod_id": "dualsource",
            "features_heading": "Salient Features",
            "salient_features": ["Directly replaces 2 energy meters",
                " Sensing dual source through 240V connection",
                "Dual row display switches based on the source",
                "Optional digital output separately for EB or DG parameters",
            ],
            "app_heading": "Applications",
            "app_list": [
                " To measure dual power source",
                "Dual source energy billing",
                "  Industries, residential, commercial buildings",
                "  Generator & control panels",
            ]
        },
        {
            "id": 7,
            "heading": "DC Energy Meter",
            "top_desc": "Smart device for all renewal energy resources",
            "image": '../assets/images/dcenergymeter.webp',
            "bottom_desc": " Multi-channel DC Energy | Voltage/Current full scale ",
            "prod_id": "dcenergy",
            "features_heading": "Salient Features",
            "salient_features": [
                "Multiple channels can be measured by a single meter, EN2450N & EN2450D",
                " Differential current input for all the current channels ",
                "Programmable shunt secondary 50mV to 100mV",
                " Programmable CT Primary for all channels up to 200A - for Hall Effect CT",
                " Data logging for parameters such as Energy, Load hours and Ampere hours",
                " Easy installation,Compact size, weight and simple wiring",
            ],
            "app_heading": "Applications",
            "app_list": [
                "DC Measurement",
                "Equipment Monitoring",
                "  Genset, Solar and UPS applications",
                " In control panel to measure different electrical loads "
            ]
        }
    ]
};

const SmartControl = {
    'Title': 'Smart Controller',
    'Products': [{
            "id": 1,
            "heading": "Power Quality Meter",
            "top_desc": " Measure, record and visualize electrical network parameters ",
            "image": '../assets/images/powerqualitymeter.webp',
            "bottom_desc": " Multifunction Meter | Power quality | Load Manager | Demand controller | Power quality | Harmonics ",
            "features_heading": "Salient Features",
            "salient_features": [
                "Power quality meter displays waveform for instantaneous V,I, harmonics,Sag/Swell with data storage upto 14GB",
                "Measurement of THD and harmonics up to 63 rd order is possible with power quality meter",
                "Captures and measures power quality events: flicker, K factor, crest factor,sag/swell, interruption & unbalance",
                "TOD option for energy & demand upto 8 slots",
                "Power quality meter monitors performance & availability of devices using inbuilt MQTT & TCP/IP protocol",
                "Power quality meter is an ideal choice for remote monitoring of devices via M2M software platform",
            ],
            "app_heading": "Applications",
            "app_list": ["Monitoring critical load,incomers, and HT panels ",
                " Utility billing in Apartments and commercial complexes",
                " Measuring energy variants in Building Management system",
                " Measuring power & energy variants in Gensets, Test benches, and the laboratories",
            ]
        },
        {
            "id": 2,
            "heading": "Digital Panel Meter",
            "top_desc": "Basic parameters measured precisely",
            "image": '../assets/images/digitalpanel.webp',
            "bottom_desc": " Ammeter | Volt meter | VAF Meter | Hz Meter | Frequency MeterDC Meter | RPM & MPM | Transducer Output ",
            "prod_id": "digitalpanelmeter",
            "features_heading": "Salient Features",
            "salient_features": [
                "Inbuilt Selector Switch",
                "High resolution reading with autoscaling",
                "Suitable for industrial panels, gen-sets, solar, pump control panels, etc.",
                "Optional RS485 for data collection",
                "  Optional easy interface to PLC through modbus protocol ",
            ],
            "app_heading": "Applications",
            "app_list": [
                "AC & DC Measurement ",
                " Equipment Monitoring",
                "  Genset, Solar and UPS applications",
                " In control panel to measure different electrical loads"
            ],
        },
        {
            "id": 3,
            "heading": " Multifunction Meter",
            "top_desc": "Simultaneous measurement of various electrical parameters",
            "image": '../assets/images/multifunctionmeter.webp',
            "bottom_desc": " Basic | Power | Energy | Load Manager Digital Output | Pulse Output ",
            "prod_id": "multifunction",
            "features_heading": "Salient Features",
            "salient_features": [
                "Easy navigation",
                "Event recording with time stamp (all basic & power parameters)",
                "Unbalance load and voltage with calculated neutral current.",
                "Dynamic communication",
                "  Optional digital output for all basic and power parameters ",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Monitoring Electrical Parameters ",
                "Control / protection",
                "  In control panel to measure different electrical loads",
                " Generator & control panels",
            ]
        },
        {
            "id": 4,
            "heading": " Branch Circuit Monitor",
            "top_desc": "Compact device to enroute multiple channels",
            "image": '../assets/images/branchcircuitmonitor.webp',
            "bottom_desc": " Multi-channel load manager | Power distribution unit ",
            "prod_id": "branchcircuitmonitor",
            "features_heading": "Salient Features",
            "salient_features": [
                "Multiple branches of load can be monitored together",
                " Faster communication through RS485 port (Modbus protocol)d",
                "Accuracy Class 1.0 as per IEC 62053-21 & Class 0.5 as per IEC 62053-22 Standards",
                "Displays more than 25 parameters",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Remote reading and control",
                "Building management system",
                " In control panel to measure different electrical loads",
                "  Ideal for billing in apartments/commercial complexes",
            ]
        },
        {
            "id": 5,
            "heading": " Generator Monitoring Unit",
            "top_desc": "Generator monitoring device with dual display",
            "image": '../assets/images/generatormonitoringunit.webp',
            "bottom_desc": " Counter & LED Display | Pulse Output ",
            "prod_id": "generalmoitoringunit",
            "features_heading": "Salient Features",
            "salient_features": [
                "Avoids the requirement of 2 different meters (energy and VAF in one)",
                " Reduces the cost and simplify wiring",
                "High resolution reading with auto scaling in LED",
                "Energy consumption in counter even if CT is reversed",
            ],
            "app_heading": "Applications",
            "app_list": [
                " Easy configuration of Gen-set Controllers",
                "Monitor health & Readiness",
                " Remote operation & control",
                "  Multiple alarms & notifications"
            ]
        },
        {
            "id": 6,
            "heading": " Dual Source Energy Meter",
            "top_desc": "Collecting data from two different sources of energy",
            "image": '../assets/images/dualsourceenergymeter.webp',
            "bottom_desc": " Multifunction meter | Dual source measurement ",
            "prod_id": "dualsource",
            "features_heading": "Salient Features",
            "salient_features": ["Directly replaces 2 energy meters",
                " Sensing dual source through 240V connection",
                "Dual row display switches based on the source",
                "Optional digital output separately for EB or DG parameters",
            ],
            "app_heading": "Applications",
            "app_list": [
                " To measure dual power source",
                "Dual source energy billing",
                "  Industries, residential, commercial buildings",
                "  Generator & control panels",
            ]
        },
        {
            "id": 7,
            "heading": "DC Energy Meter",
            "top_desc": "Smart device for all renewal energy resources",
            "image": '../assets/images/dcenergymeter.webp',
            "bottom_desc": " Multi-channel DC Energy | Voltage/Current full scale ",
            "prod_id": "dcenergy",
            "features_heading": "Salient Features",
            "salient_features": [
                "Multiple channels can be measured by a single meter, EN2450N & EN2450D",
                " Differential current input for all the current channels ",
                "Programmable shunt secondary 50mV to 100mV",
                " Programmable CT Primary for all channels up to 200A - for Hall Effect CT",
                " Data logging for parameters such as Energy, Load hours and Ampere hours",
                " Easy installation,Compact size, weight and simple wiring",
            ],
            "app_heading": "Applications",
            "app_list": [
                "DC Measurement",
                "Equipment Monitoring",
                "  Genset, Solar and UPS applications",
                " In control panel to measure different electrical loads "
            ]
        }
    ]
};

const SmartResource = {
    'Title': 'Smart Resources',
    'Products': [{
            "id": 1,
            "heading": "Automatic Transfer Switch",
            "top_desc": "Seamless switching between sources for uninterrupted supply.",
            "image": '../assets/images/automatictransferswitch.webp',
            "bottom_desc": " Overload Tripping Logic | Automatic DG Start/Stop | Fire/External Fault Trip | Safe and Rapid Switching | Automatic Transfer",
            "prod_id": "automatictransferswitch",
            "features_heading": "Salient Features",
            "salient_features": [
                "Automatic start/stop operation of DG on mains failure Overload tripping (optional) with inverse curve logic",
                "Automatic transfer switch are provided with fire alarm / external fault trip feature",
                "Inbuilt control switch for selecting auto/manual mode",
                "Automatic transfer switch have high capacity to withstand short circuit",
                "Optional RS485 communication and cloud",
            ],
            "app_heading": "Applications",
            "app_list": ["Monitor real-time system voltage and frequency ",
                " Monitor source healthiness and output for both Source",
                " Wide range of motor operating voltage from 150VAC – 285V AC",
                " Automatic transfer switch for commercial centers, manufacturing, medical facilities,and data centers.",
            ]
        },
        {
            "id": 2,
            "heading": "Manual Transfer Switch",
            "top_desc": "MANUALLY CONTROL YOUR POWER SOURCE",
            "image": '../assets/images/manualtransferswitch.webp',
            "bottom_desc": " User-friendly Installation | Safe Changeover",
            "prod_id": "manualtransfermeter",
            "features_heading": "Salient Features",
            "salient_features": [
                "High short-circuit withstand capacity",
                "Quick-make & quick-break operation for transferring of loads",
                "Operating handle with provision to lock in ON/OFF position",
                "Safest changeover during the failure of a primary source",
                " Facilitate easy installation and simplified wiring connections",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Generator OEM’s ",
                "Commercial buildings",
                "Automobile Industry & Manufacturing Industry",
                "Power distribution and Load Management."
            ],
        },
        {
            "id": 3,
            "heading": "Prepaid/Postpaid Meter",
            "top_desc": "Prepaid meter is a Single Device for electricity, gas and water measurement. Prepaid meter",
            "image": '../assets/images/prepaidpostpaidmeter.webp',
            "bottom_desc": " Multifunction | Dual source | Over voltage/current cut off for protection | Post paid meter | Prepaid meter ",
            "prod_id": "prepaidpostmeter",
            "features_heading": "Salient Features",
            "salient_features": [
                "User friendly contactless prepaid metering solution",
                "Prepaid meter with LoRa helps you to make private network being independent of service provider",
                "Integration of Gas & Water with the electrical parameters thereby, extending the flexibility for the user to budget expenses",
                "Tripping of EB or DG consumption at pre-determined set point for protection & effective use of energy",
                "Recharge your prepaid meter & have explicit view of energy usage & tariff rates from anywhere",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Shopping complex",
                "Residential layouts / apartments",
                "A Automate power distribution, protect expensive equipment and prevent fatal risks",
                "ACCL Logic for Currents up to 120 Amps is available.",
            ]
        },
        {
            "id": 4,
            "heading": " Power Analyzer",
            "top_desc": "High profile power analyzer with higher accuracy and data logging",
            "image": '../assets/images/poweranalyzer.webp',
            "bottom_desc": "Handheld Power Quality Analyzer | Power Analyzer | Harmonic Analyzer ",
            "prod_id": "poweranalyzer",
            "features_heading": "Salient Features",
            "salient_features": [
                "Helps you locate, predict, prevent & troubleshoot problems in power distribution",
                "Measures voltage, current, frequency, power, energy consumption, unbalance, harmonics & inter-harmonics",
                "24x7 cloud server data logging with time stamp",
                "Monitor & control large campuses or remote facilities with inexpensive web technology.",
                "Perform audits & analyzes remotely.",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Reduce energy costs & Acheive maximum Returns on Investment.",
                "Higher Performance, easy to configure but economically priced",
                "Supports various Protocols, Identifies & Eliminates energy waste.",
                "Security & System Integration, improves Working envronment.",
            ]
        },
        {
            "id": 5,
            "heading": " ACCL",
            "top_desc": "Accl (Automatic Source Changeover with Current Limiter) For a seamless, uninterrupted changeover between power sources. Accl Changeover Switch manufacturers in India",
            "image": '../assets/images/accl.webp',
            "bottom_desc": "ACCL | Automatic Changeover Current Limiter | Frequency | Energy",
            "prod_id": "accl",
            "features_heading": "Salient Features",
            "salient_features": [
                "Microcontroller based automatic source changeover with neutral isolation",
                "Intelligent re-connection once trip has occurred due to either overvoltage or overload",
                "Optional iACCL with Prepaid Metering feature can be given for DG side",
                "Individual phase overload monitoring in 3 phase ACCL & overvoltage protection for DG",
                "Inbuilt display & measurement of I, V, F and KWh on the both generator & mains in iACCL M600",
            ],
            "app_heading": "Applications",
            "app_list": [
                "ACCL perform intelligent tripping to save the age of the cables",
                "Reduced wiring cost as single phase ACCL has separate control for power and lighting load",
                "A Automate power distribution, protect expensive equipment and prevent fatal risks",
                "ACCL Logic for Currents up to 120 Amps is available."
            ]
        },
        // {
        //     "id": 6,
        //     "heading": "Power Quailyt Analayzer",
        //     "top_desc": "Prepaid meter is a Single Device for electricity, gas and water measurement. Prepaid meter manufactures in India",
        //     "image": '../assets/images/powerqualityanalyzer.webp',
        //     "bottom_desc": "Multifunction | Dual source | Over voltage/current cut off for protection | Post paid meter | Prepaid meter",
        //     "prod_id": "powerqualityanalyzer",
        //     "features_heading": "Salient Features",
        //     "salient_features": ["Real time monitoring and reporting",
        //         "Composite system with EMS and PEMS",
        //         "Desired reports like, Doff wise, shift wise, count wise, production, energy, UKG",
        //         "Speed Vs Kw curve, trends, bar graphs, comparisons",
        //         "Alerts on higher UKG, lesser production, utilization & power fluctuations.",
        //         "Maintenance alerts based on run hours production cost analysis - Cost Audits - Energy Audits",
        //     ],
        //     "app_heading": "Applications",
        //     "app_list": [
        //         " Energy savings will bring down operational cost & increases the plant efficiency",
        //         "Scheduling of preventive maintenance",
        //         "Higher productivity- Lesser downtime",
        //         "Effective utilization of manpower and resources",
        //     ]
        // },
        {
            "id": 6,
            "heading": "Smart I/O",
            "top_desc": "Smartest way to capture the input & communicate data output",
            "image": '../assets/images/smartio.webp',
            "bottom_desc": "Universal Input | Universal Output | Digital Output",
            "prod_id": "smartio",
            "features_heading": "Salient Features",
            "salient_features": [
                "Up to 8 Universal Inputs field configurable",
                " Up to 4 Universal Outputs field configurable ",
                " 6 SSR outputs and 2 relay outputs (optional)",
                " Communication LON / RS485",
                " Pluggable terminal blocks, for installation wiring and ease of maintenance",
                
            ],
            "app_heading": "Applications",
            "app_list": [
                "Lighting management",
                "Breaker status monitoring",
                " Home automation.",
                
            ]
        }
    ]
};


const SmartNetwork = {
    'Title': 'Smart Networking',
    'Products': [{
            "id": 1,
            "heading": "Split Core CT",
            "top_desc": "Seamless switching between sources for uninterrupted supply.Automatic Transfer Switch manufactures in India",
            "image": '../assets/images/splitcorect.webp',
            "bottom_desc": " Overload Tripping Logic | Automatic DG Start/Stop | Fire/External Fault Trip | Safe and Rapid Switching | Automatic Transfer",
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Automatic start/stop operation of DG on mains failure Overload tripping (optional) with inverse curve logic",
                "Automatic transfer switch are provided with fire alarm / external fault trip feature",
                "Inbuilt control switch for selecting auto/manual mode",
                "Automatic transfer switch have high capacity to withstand short circuit",
                "Optional RS485 communication and cloud",
            ],
            "app_heading": "Applications",
            "app_list": ["Monitor real-time system voltage and frequency ",
                " Monitor source healthiness and output for both Source",
                " Wide range of motor operating voltage from 150VAC – 285V AC",
                " Automatic transfer switch for commercial centers, manufacturing, medical facilities,and data centers.",
            ]
        },
        {
            "id": 2,
            "heading": "Converter",
            "top_desc": "Seamless switching between sources for uninterrupted supply. Automatic Transfer Switch manufactures in India",
            "image": '../assets/images/converter.webp',
            "bottom_desc": " Overload Tripping Logic | Automatic DG Start/Stop | Fire/External Fault Trip | Safe and Rapid Switching | Automatic Transfer",
            "prod_id": "converter",
            "features_heading": "Salient Features",
            "salient_features": [
                "Automatic start/stop operation of DG on mains failure Overload tripping (optional) with inverse curve logic",
                "Automatic transfer switch are provided with fire alarm / external fault trip feature",
                "Inbuilt control switch for selecting auto/manual mode",
                "Automatic transfer switch have high capacity to withstand short circuit",
                " Optional RS485 communication and cloud",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Monitor real-time system voltage and frequency.",
                "Monitor source healthiness and output for both Source",
                "Wide range of motor operating voltage from 150VAC – 285V AC",
                "Automatic transfer switch for commercial centers, manufacturing, medical facilities,and data centers."
            ],
        },
        {
            "id": 3,
            "heading": "Gateway",
            "top_desc": "Seamless switching between sources for uninterrupted supply. Automatic Transfer Switch manufactures in India",
            "image": '../assets/images/gateway.webp',
            "bottom_desc": " Overload Tripping Logic | Automatic DG Start/Stop | Fire/External Fault Trip | Safe and Rapid Switching | Automatic Transfer ",
            "prod_id": "gateway",
            "features_heading": "Salient Features",
            "salient_features": [
                "User friendly contactless prepaid metering solution",
                "Automatic start/stop operation of DG on mains failure Overload tripping (optional) with inverse curve logic",
                "Automatic transfer switch are provided with fire alarm / external fault trip feature.",
                "Inbuilt control switch for selecting auto/manual mode.",
                "Automatic transfer switch have high capacity to withstand short circuit.",
                "Optional RS485 communication and cloud.",
            ],
            "app_heading": "Applications",
            "app_list": [
                "Monitor real-time system voltage and frequency",
                "Monitor source healthiness and output for both Source",
                "Wide range of motor operating voltage from 150VAC – 285V AC",
                "Automatic transfer switch for commercial centers, manufacturing, medical facilities,and data centers.",
            ]
        },
        
    ]
};

const Eaton = {
    'Title': 'MCCB Products',
    'Products': [{
        "id": 1,
        "heading": "xPole Combined RCD/MCB Device PKNM, 1+N-pole",
        "image": '../assets/images/eaton/mcb1.webp',
        "paragraph": "This residual current operated circuit breaker with integrated overcurrent protection in 1+N pole is a high-quality residual current circuit breaker and miniature circuit breaker combination. This RCD/MCB combination PKNM switch is not only available as an AC and pulse current sensitive standard type A, but also as a mixing frequency sensitive type F, as a type G or G/A triggering with a time delay of at least 10 ms. While the AC and the A are only impulse current resistant up to 250 A, the other three types F, G and G/A offer an increased impulse current resistance of more than 3 kA.",
        "features": {
            "rated_current": "up to 40 A",
            "compliant_to": "IEC/EN 61009",
            "rated_breaking_capacity": "6 kA or 10 kA",
        }
      },
      
      {
        "id": 2,
        "heading": "xEffect Combined RCD/MCB Device, FRBmM, 1+N, 2, 3 and 3+N-pole",
        "image": "../assets/images/eaton/eatonxeffect.webp",
        "paragraph": "This residual current operated circuit breaker with integrated overcurrent protection is a high-quality residual current circuit breaker and miniature circuit breaker combination with line voltage-independent tripping and a wide variety of rated tripping currents. A tripping by a fault current is signalled by the blue display, white indicates that either the MCB part was tripped or that it was switched off. It is compatible with Busbars. A twin-purpose terminal (lift/open-mouthed) is available for easy and quick mounting.",
        "features": {
            "rated_current": "up to 40 A",
            "compliant_to": "IEC/EN 61009",
            "rated_breaking_capacity": "6 kA or 10 kA",
        }},

      {
        "id": 5,
        "heading": "xEffect Combined RCD/MCB Device, FRBmM, 1+N, 2, 3 and 3+N-pole",
        "image": "../assets/images/eaton/eatonxeffectrcbo.webp",
        "paragraph": "This residual current operated circuit breaker with integrated overcurrent protection is a high-quality residual current circuit breaker and miniature circuit breaker combination with line voltage-independent tripping and a wide variety of rated tripping currents. A tripping by a fault current is signalled by the blue display, white indicates that either the MCB part was tripped or that it was switched off. It is compatible with Busbars. A twin-purpose terminal (lift/open-mouthed) is available for easy and quick mounting.",
        "features": {
            "rated_current": "up to 40 A",
            "compliant_to": "IEC/EN 61009",
            "rated_breaking_capacity": "6 kA or 10 kA",
        }},

      {
        "id": 6,
        "heading": "AZ xEffect Miniature Circuit Breaker",
        "image": "../assets/images/eaton/eatonaz.webp",
        "paragraph": "The AZ miniature circuit breaker is a protective device equipped with both a thermal and an electromagnetic release that is available in 1-, 2-, 3-, 4- and 3+N pole versions. The AZ is suitable for both AC and DC applications (60 V per pole) with rated currents from 20 A to 125 A. Depending on the device type, it has a switching capacity of up to 25 kA according to IEC/EN 60947-2.",
        "features": {
            "rated_current": "1-, 2-, 3-, 4- and 3+N pole",
            "compliant_to": "IEC/EN 60947-2",
            "rated_breaking_capacity": "up to 125 A",
        }},

      {
        "id": 8,
        "heading": "PLS6-DC and PL10-DC-IN xPole Miniature Circuit Breaker",
        "image": "../assets/images/eaton/eatonminiature.webp",
        "paragraph": "The PLS6 miniature circuit breaker (MCB) is a protective device that’s equipped with both a thermal and an electromagnetic release. The former responds in the event of an overload, while the latter offers protection against short circuits. The 1- and 2-pole PLS6 devices for DC applications are available with rated currents from 1 A to 50 A and 4P PL10 devices for DC application are available with rated currents from 16A to 50A and can withstand rated voltages of up to 250 V DC Per pole. The switching capacity is 10 kA. The PLS6-DC and PL10-DC-IN is busbar compatible, and double life/claw terminals are available at the top as well as at the bottom for easy mounting.",
        "features": {
            "rated_current": "compliant MCB",
            "compliant_to": "up to 50 A",
            "rated_breaking_capacity": "C",
        }},
        // {
        //     "id": 9,
        //     "heading": "BZM Molded Case Circuit Breaker",
        //     "image": '../assets/images/eaton/mcb1.webp',
        //     "paragraph": "Eaton's BZM Molded Case Circuit Breakers offer optimum and efficient protection for low voltage applications in power distribution systems. The advantage of the BZM series is its simple use: The thermal and magnetic release system for over-current and short-circuit protection of your system is already factory set. Along with simple handling of the product and its accessories, Eaton’s BZM offering provides an attractive product assortment.",
        //     "features": {
        //         "rated_current": "up to 40 A",
        //         "compliant_to": "IEC/EN 61009",
        //         "rated_breaking_capacity": "6 kA or 10 kA",
        //         }
        //     },
        
            // {
            //     "id": 10,
            //     "heading": "NZM Molded Case Circuit Breaker",
            //     "image": "../assets/images/eaton/eatonaz.webp",
            //     "paragraph": "The new Eaton circuit-breakers cover a range from 15 to 1600 A with just four frame sizes. And they are optimally matched to one another. The wide application spectrum covers every requirement as Eaton has closely examined what every customer needs and implemented the appropriate solutions. Outstanding, for example, is the continuous switching power range – which extends from the smallest to the largest circuit-breaker or the modular system which can be matched without difficulty to suit the specific application.",
            //     "features": {
            //         "rated_current": "15 to 1600 A",
            //         "compliant_to": "1- and 2-pole",
            //         "rated_breaking_capacity": "150 kA.",
            //     }
            // },

            // {
            //     "id": 11,
            //     "heading": "Emergency Lighting System",
            //     "image": "../assets/images/eaton/light/light.webp",
            //     "paragraph": "The ELPS502 Model #M05 Emergency Lighting System is designed to automatically provide illumination to designated areas during failure or interruption of power to the normal lighting system. The ELPS502 is factory assembled and wired, and consists of one (1) ELPS50 power supply and two (2) EVLA lighting fixtures The ELPS50 power supply consists of a battery supply and battery recharging system housed inside a hazardous area enclosure with all the circuitry to automatically turn on emergency DC lighting fixture(s) when the normal power supply fails",
            //     "features": {
            //         "rated_current": "15 to 1600 A",
            //         "compliant_to": "1- and 2-pole",
            //         "rated_breaking_capacity": "150 kA.",
            //     }
            // },

            // {
            //     "id": 12,
            //     "heading": "Selecting Protective Devices",
            //     "image": "../assets/images/eaton/spd/spd.webp",
            //     "paragraph": "Eaton’s Bussmann series Selecting Protective Devices (SPD) handbook. This reference document is based on the 2017 National Electrical Code (NEC ® ) and is a comprehensive guide to electrical overcurrent protection and electrical design considerations. The information within this resource is presented on numerous applications as well as code and standard requirements for a variety of electrical equipment and distribution systems.",
            //     "features": {
            //         "rated_current": "15 to 1600 A",
            //         "compliant_to": "1- and 2-pole",
            //         "rated_breaking_capacity": "150 kA.",
            //     }
            // },

            // {
            //     "id": 9,
            //     "heading": "Eaton Contractors",
            //     "image": "../assets/images/eaton/contractor/eatonmoeller.webp",
            //     "paragraph": "",
            //     "features": {
            //         "rated_current": "15 to 1600 A",
            //         "compliant_to": "1- and 2-pole",
            //         "rated_breaking_capacity": "150 kA.",
            //     }
            // },
        ]
};

const Eatonmcb = {
    'Title': 'MCB Products',
    'Products': [{
        "id": 1,
        "heading": "Miniature Circuite Breaker(MCB), 10A, 1p",
        "image": '../assets/images/eaton/mcb/plsm10.webp',
        "paragraph": "Miniature circuit breaker (MCB), PLSM, 2-pole, tripping characteristic: C, rated current In: 10 A, rated switching capacity according to IEC/EN 60898-1: 10 kA, Switchgear for residential and commercial applications",
        "features": {
            "rated_current": "up to 10A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "10 kA",
        }
      },
      {
        "id": 2,
        "heading": "Miniature Circuite Breaker(MCB), 16A, 1p",
        "image": '../assets/images/eaton/mcb/plsm16.webp',
        "paragraph": "Miniature circuit breaker (MCB), PLSM, 2-pole, tripping characteristic: C, rated current In: 16 A, rated switching capacity according to IEC/EN 60898-1: 10 kA, Switchgear for residential and commercial applications",
        "features": {
            "rated_current": "up to 16A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "10 kA",
        }
      },

      {
        "id": 3,
        "heading": "Miniature Circuite Breaker(MCB), 20A, 1p",
        "image": '../assets/images/eaton/mcb/plsm.webp',
        "paragraph": "Miniature circuit breaker (MCB), PLSM, 1-pole, tripping characteristic: C, rated current In: 20 A, rated switching capacity according to IEC/EN 60898-1: 10 kA, Switchgear for residential and commercial applications",
        "features": {
            "rated_current": "up to 20A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "10 kA",
        }
      },
      {
        "id": 4,
        "heading": "FAZ-NA xEffect Miniature Circuit Breaker",
        "image": "../assets/images/eaton/eatonfaz.webp",
        "paragraph": "The FAZ-NA / FAZ-RT miniature circuit breaker is a protective device equipped with both a thermal and an electromagnetic release that is available in 1-, 2-, 3- and 4- pole versions. The FAZ-NA is available with rated currents of 0.5 A to 63 A. The switching capacity is 15 kA according to IEC/EN 60947-2, and 10 kA or 14 kA according to UL 489/CSA C22.2 No. 5, depending on the device type.",
        "features": {
            "rated_current": "on DIN rail",
            "compliant_to": "1-, 2-, 3- and 4-pole",
            "rated_breaking_capacity": "3",
        }
      },
      {
        "id": 5,
        "heading": "FAZ-NA-DC xEffect Miniature Circuit Breaker",
        "image": "../assets/images/eaton/eatonfaznadc.webp",
        "paragraph": "The FAZ-NA-DC miniature circuit breaker is a protective device that is equipped with both a thermal and an electromagnetic release. The FAZ-NA-DC for DC applications is available in 1-pole and 2-pole versions with rated currents from 2 A to 40 A. The switching capacity is 10 kA according to IEC/EN 60947-2, UL 489 and CSA C22.2 No. 5. The DC rated voltage for all types is 125 V per pole according to UL 489/CSA C22.2 No. 5, and 220 V per pole for the 2 A version / 250 V per pole for the 3 A to 40 A versions according to IEC/EN 60947-2.",
        "features": {
            "rated_current": "C",
            "compliant_to": "1- and 2-pole",
            "rated_breaking_capacity": "up to 40 A",
        }},

        {
            "id": 4,
            "heading": "FAZ-DC xEffect Miniature Circuit Breaker",
            "image": "../assets/images/eaton/eatonfazdc.webp",
            "paragraph": "The FAZ-DC miniature circuit breaker is a protective device equipped with both a thermal and an electromagnetic release that is available in 1- and 2-pole versions. The FAZ is available with rated currents of 2 A to 50 A. The switching capacity is 10 kA according to IEC/EN 60947-2 The DC rated voltage is 220 V per pole for the 2 A version, and 250 V per pole for the 3 A to 50 A versions. A guide for secure terminal connection and a 3-position DIN-rail simplify the installation of the circuit breaker.",
            "features": {
                "rated_current": "IEC/EN 60947-2",
                "compliant_to": "up to 50 A",
                "rated_breaking_capacity": "1- and 2-pole",
            }},]
};
const Eatonacb = {
    'Title': 'ACB Products',
    'Products': [{
        "id": 1,
        "heading": "IZMX16B3-A12W - Circuit-breaker 3p, 1250A, withdrawable",
        "image": "../assets/images/eaton/acb/izmxa16.webp",
        "paragraph": "Circuit-breaker IZMX16 ( Air circuit-breakers/switch-disconnectors), 3 pole, Current Range: Up to 4000 A, Rated current = rated uninterrupted current( In = Iu): 1250 A, Rated ultimate short-circuit breaking capacity up to 440V/690V 42/42( Icu): 42 kA, Rated service short-circuit breaking capacity up to 440V/690V 42/42( Ics): 42 kA, Overload release, min.( Ir): 625 A, Overload release, max.( Ir): 1250 A, Installation type: Withdrawable, Standard/Approval: IEC, Protective function: System protection",
        "features": {
            "rated_current": "1250A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 42 kA",
        }
    },
    {
        "id": 2,
        "heading": "IZMX16B3-A16W - Circuit-breaker 3p, 1600A, withdrawable",
        "image": "../assets/images/eaton/acb/izmxa16.webp",
        "paragraph": "Circuit-breaker IZMX16 ( Air circuit-breakers/switch-disconnectors), 3 pole, Current Range: Up to 4000 A, Rated current = rated uninterrupted current( In = Iu): 1600 A, Rated ultimate short-circuit breaking capacity up to 440V/690V 42/42( Icu): 42 kA, Rated service short-circuit breaking capacity up to 440V/690V 42/42( Ics): 42 kA, Overload release, min.( Ir): 800 A, Overload release, max.( Ir): 1600 A, Installation type: Withdrawable, Standard/Approval: IEC, Protective function: System protection",
        "features": {
            "rated_current": "4000 to 6300A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 4000A",
        }
    },
    {
        "id": 3,
        "heading": "IZMX40N3-A08F - Circuit-breaker, 3p, 800A, fixed",
        "image": "../assets/images/eaton/acb/izmxa10.webp",
        "paragraph": "Circuit-breaker IZMX40 ( Air circuit-breakers/switch-disconnectors), 3 pole, Current Range: Up to 4000 A, Rated current = rated uninterrupted current( In = Iu): 800 A, Rated ultimate short-circuit breaking capacity up to 440V/690V 42/42( Icu): 85 kA, Rated service short-circuit breaking capacity up to 440V/690V 42/42( Ics): 85 kA, Overload release, min.( Ir): 400 A, Overload release, max.( Ir): 800 A, Installation type: Fixed, Standard/Approval: IEC, Protective function: System protection",
        "features": {
            "rated_current": "4000 to 6300A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 4000A",
        }
    },
    {
        "id": 4,
        "heading": "IZMX16B3-A10F - Circuit-breaker 3p, 1000A, fixed",
        "image": "../assets/images/eaton/acb/izmxa10f.webp",
        "paragraph": "Circuit-breaker IZMX16 ( Air circuit-breakers/switch-disconnectors), 3 pole, Current Range: Up to 4000 A, Rated current = rated uninterrupted current( In = Iu): 1000 A, Rated ultimate short-circuit breaking capacity up to 440V/690V 42/42( Icu): 42 kA, Rated service short-circuit breaking capacity up to 440V/690V 42/42( Ics): 42 kA, Overload release, min.( Ir): 500 A, Overload release, max.( Ir): 1000 A, Installation type: Fixed, Standard/Approval: IEC, Protective function: System protection",
        "features": {
            "rated_current": "4000 to 6300A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 4000A",
        }
    },]
    
};
const Eatoncontactor = {
    'Title': 'Contactors',
    'Products': [{
        "id": 1,
        "heading": "DILM80(RDC24)-GVP - Contactor, 3p, 37kW/400V/AC3",
        "image": "../assets/images/eaton/contactor/dilm80.webp",
        "paragraph": "Contactor, Application: Contactors for Motors, Contactors up to 170 A, 3 pole, Utilization category: AC-1: Non-inductive or slightly inductive loads, resistance furnaces, NAC-3: Normal AC induction motors: starting, switch off during running, AC-4: Normal AC induction motors: starting, plugging, reversing, inching, Connection technique: Screw terminals, Notes: Also suitable for motors with efficiency class IE3, Number of poles: 3 pole, Rated operational current AC-3 380 V 400 V: Ie= 80 A, Rated operational current AC-1 Conventional free air thermal current, 3 pole, 50 - 60 Hz Open at 40 °C: Ith =Ie= 110 A, enclosed: Ith= 80 A, Rated operational current AC-1 Conventional free air thermal current, 1 pole open: Ith= 225 A, enclosed: Ith= 200 A, Max. rating for three-phase motors, 50 - 60 Hz AC-3 220 V 230 V: P= 25 kW, 380 V 400 V: P= 37 kW, 660 V 690 V: P= 63 kW, Max. rating for three-phase motors, 50 - 60 Hz AC-4 220 V 230 V: P= 11.5 kW, 380 V 400 V: P= 20 kW, 660 V 690 V: P= 26 kW, Can be combined with auxiliary contact: DILM150-XHI(V).., DILM1000-XHI(V).., Instructions: Contacts to EN 50 012., integrated suppressor circuit in actuating electronics, Voltage AC/DC: DC operation",
        "features": {
            "rated_current": "160A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 800 A",
        }        
    },
    {
        "id": 2,
        "heading": "173385 DILM185A/22(RAC240)-SOND730",
        "image": "../assets/images/eaton/contactor/dilm185a.webp",
        "paragraph": "Contactor, Application: Contactors for Motors, Standard devices greater than 170 A, Utilization category: AC-1: Non-inductive or slightly inductive loads, resistance furnaces, NAC-3: Normal AC induction motors: starting, switch off during running, AC-4: Normal AC induction motors: starting, plugging, reversing, inching, Connection technique: Screw connection, Rated operational current AC-3 380 V 400 V: Ie= 185 A, Rated operational current AC-1 Conventional free air thermal current, 3 pole, 50 - 60 Hz Open at 40 °C: Ith =Ie= 337 A, enclosed: Ith= 245 A, Rated operational current AC-1 Conventional free air thermal current, 1 pole open: Ith= 685 A, enclosed: Ith= 625 A, Max. rating for three-phase motors, 50 - 60 Hz AC-3 220 V 230 V: P= 55 kW, 380 V 400 V: P= 90 kW, 660 V 690 V: P= 140 kW, Max. rating for three-phase motors, 50 - 60 Hz AC-4 220 V 230 V: P= 41 kW, 380 V 400 V: P= 75 kW, 660 V 690 V: P= 102 kW, Can be combined with auxiliary contact: DILM1000-XHI…, Contacts N/O = Normally open: 2 N/O, Contacts N/C = Normally closed: 2 NC, Instructions: integrated suppressor circuit in actuating electronics, 660 V, 690 V or 1000 V: not directly reversing, Voltage AC/DC: AC operation",
        "features": {
            "rated_current": "185A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "2250 A",
        }        
    },
    {
        "id": 3,
        "heading": "173389 DILM185A/22(RDC60)-SOND730",
        "image": "../assets/images/eaton/contactor/dilm185a22.webp",
        "paragraph": "Contactor, Application: Contactors for Motors, Standard devices greater than 170 A, Utilization category: AC-1: Non-inductive or slightly inductive loads, resistance furnaces, NAC-3: Normal AC induction motors: starting, switch off during running, AC-4: Normal AC induction motors: starting, plugging, reversing, inching, Connection technique: Screw connection, Rated operational current AC-3 380 V 400 V: Ie= 185 A, Rated operational current AC-1 Conventional free air thermal current, 3 pole, 50 - 60 Hz Open at 40 °C: Ith =Ie= 337 A, enclosed: Ith= 245 A, Rated operational current AC-1 Conventional free air thermal current, 1 pole open: Ith= 685 A, enclosed: Ith= 625 A, Max. rating for three-phase motors, 50 - 60 Hz AC-3 220 V 230 V: P= 55 kW, 380 V 400 V: P= 90 kW, 660 V 690 V: P= 140 kW, Max. rating for three-phase motors, 50 - 60 Hz AC-4 220 V 230 V: P= 41 kW, 380 V 400 V: P= 75 kW, 660 V 690 V: P= 102 kW, Can be combined with auxiliary contact: DILM1000-XHI…, Contacts N/O = Normally open: 2 N/O, Contacts N/C = Normally closed: 2 NC, Instructions: integrated suppressor circuit in actuating electronics, 660 V, 690 V or 1000 V: not directly reversing, Voltage AC/DC: DC operation",
        "features": {
            "rated_current": "185A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 2250 A",
        }        
    },
    {
        "id": 4,
        "heading": "104811 DILM25-01(RDC12)",
        "image": "../assets/images/eaton/contactor/dilm25.webp",
        "paragraph": "Contactor, Application: Contactors for Motors, Contactors up to 170 A, 3 pole, Utilization category: AC-1: Non-inductive or slightly inductive loads, resistance furnaces, NAC-3: Normal AC induction motors: starting, switch off during running, AC-4: Normal AC induction motors: starting, plugging, reversing, inching, Connection technique: Screw terminals, Notes: Also suitable for motors with efficiency class IE3, Number of poles: 3 pole, Rated operational current AC-3 380 V 400 V: Ie= 25 A, Rated operational current AC-1 Conventional free air thermal current, 3 pole, 50 - 60 Hz Open at 40 °C: Ith =Ie= 45 A, enclosed: Ith= 36 A, Rated operational current AC-1 Conventional free air thermal current, 1 pole open: Ith= 100 A, enclosed: Ith= 90 A, Max. rating for three-phase motors, 50 - 60 Hz AC-3 220 V 230 V: P= 7.5 kW, 380 V 400 V: P= 11 kW, 660 V 690 V: P= 14 kW, Max. rating for three-phase motors, 50 - 60 Hz AC-4 220 V 230 V: P= 3.5 kW, 380 V 400 V: P= 6 kW, 660 V 690 V: P= 8.5 kW, Can be combined with auxiliary contact: DILA-XHI(V).., Instructions: Contacts to EN 50 012., integrated suppressor circuit in actuating electronics, with mirror contact., Voltage AC/DC: DC operation",
        "features": {
            "rated_current": "N/A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 250 A",
        }        
    },
    {
        "id": 5,
        "heading": "Contractor- 106367 DILM7-22(24VDC)",
        "image": "../assets/images/eaton/contactor/dilm722.webp",
        "paragraph": "Contactor, Application: Contactors for Motors, Complete devices up to 170 A, Utilization category: AC-1: Non-inductive or slightly inductive loads, resistance furnaces, NAC-3: Normal AC induction motors: starting, switch off during running, AC-4: Normal AC induction motors: starting, plugging, reversing, inching, Connection technique: Screw terminals, Notes: Also suitable for motors with efficiency class IE3, Rated operational current AC-3 380 V 400 V: Ie= 7 A, Rated operational current AC-1 Conventional free air thermal current, 3 pole, 50 - 60 Hz Open at 40 °C: Ith =Ie= 22 A, enclosed: Ith= 18 A, Rated operational current AC-1 Conventional free air thermal current, 1 pole open: Ith= 50 A, enclosed: Ith= 45 A, Max. rating for three-phase motors, 50 - 60 Hz AC-3 220 V 230 V: P= 2.2 kW, 380 V 400 V: P= 3 kW, 660 V 690 V: P= 3.5 kW, Max. rating for three-phase motors, 50 - 60 Hz AC-4 220 V 230 V: P= 1 kW, 380 V 400 V: P= 2.2 kW, 660 V 690 V: P= 2.9 kW, Contacts N/O = Normally open: 2 N/O, Contacts N/C = Normally closed: 2 NC, Instructions: Contacts to EN 50 012., Integrated varistor suppressor circuit., with mirror contact., Voltage AC/DC: DC operation",
        "features": {
            "rated_current": "112 A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "up to 70 kA",
        }        
    },
    {
        "id": 6,
        "heading": "SFD27-OHL 1 P BASE DII/E27 FUSES OVERHEAD LINE 25A",
        "image": "../assets/images/eaton/contactor/dline1.webp",
        "paragraph": "Fuse base, low voltage, 63 A, AC 500 V, D3, 1P, IEC Fuse accessory, Fuse-base, low voltage, 63 A, AC 500 V, D3, 1P, IEC, overhead lines, E33",
        "features": {
            "rated_current": "63 A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "N/A",
        }        
    },
    {
        "id": 7,
        "heading": "SFD33-OHL 1 P BASE DIII/E33 FUSES OVERHEAD LINE",
        "image": "../assets/images/eaton/contactor/dline2.webp",
        "paragraph": "Fuse base, low voltage, 25 A, AC 500 V, D2, 1P, IEC Fuse accessory, Fuse-base, low voltage, 25 A, AC 500 V, D2, 1P, IEC, overhead lines, E27",
        "features": {
            "rated_current": "25 A",
            "compliant_to": "IEC/EN 61439",
            "rated_breaking_capacity": "N/A",
        }        
    },]
};

const SCModules = {

    'Title': 'MANUAL/AUTO START CONTROL MODULES',
    'Products': [{
        "id": 1,
        "image": "../assets/images/deepsea/dse402.webp",
        "heading": "DSE402MKII",      
        "sub_heading": "Waterproof Manual & Auto Start Control Module",
        "paragraph": "The DSE402 MKII is a waterproof Auto/Manual Start Control Module designed for generator and engine only applications. The intelligent design combines smart features with a waterproof key switch and enclosure to provide an excellent control option for wet/humid environments. ",
        "features": {
            "overall_size": "157 mm x 111 mm x 60 mm (6.2” x 4.4” x 2.4”) Excludes Key Switch",
            "panel_cutout_size": "132 mm x 84 mm (5.2 ' x 3.4')",
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.45kg",
            "product_variants": "0402-03 - 402 MKII Waterproof Engine Control Module (Mpu)"
        }
    },
    {
        "id": 2,
        "image": "../assets/images/deepsea/dse701mkii.webp",
        "heading": "DSE701MKII",      
        "sub_heading": "Manual & Auto Start Control Module",
        "paragraph": "The DSE701 MKII is a compact control module that offers a range of features for single-set applications. The controller can be used in manual or auto start mode.",
        "features": {
            "overall_size": "72 mm x 72 mm x 38 mm (2.8” x 2.8” x 1.5”) Excludes Key Switch",
            "panel_cutout_size": '68 mm x 68 mm (2.7 " x 2.7")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.14kg",
            "product_variants": "0701-05 - 701MKII Manual & Auto Start Control Module"
        }
    },

    {
        "id": 3,
        "image": "../assets/images/deepsea/dse3110.webp",
        "heading": "DSE3110",      
        "sub_heading": "Manual & Auto Start Control Module",
        "paragraph": "The DSE3110 is an outstanding compact control module that provides a comprehensive range of features for single-set applications. The controller can be used in manual or auto start mode.",
        "features": {
            "overall_size": "98 mm x 79 mm x 40 mm (3.9” x 3.1” x 1.6”)  ",
            "panel_cutout_size": '80 mm x 68 mm (3.1 " x 2.7")',
            "maximum_panel_thickness": "8.0 mm (0.3”) ",
            "weight":"0.16kg",
            "product_variants": "3110-02 - Manual & Auto Start Control Module (Can), 3110-01 - Manual & Auto Start Control Module (Mpu)"
        }
    },

    {
        "id": 4,
        "image": "../assets/images/deepsea/dse3210.webp",
        "heading": "DSE3210",      
        "sub_heading": "Manual & Auto Start Control Module",
        "paragraph": "The DSE3210 is an outstanding compact control module that provides a comprehensive range of features for single-set applications. The controller can be used in manual or auto start mode. ",
        "features": {
            "overall_size": "98 mm x 79 mm x 40 mm (3.9” x 3.1” x 1.6”)",
            "panel_cutout_size": '80 mm x 68 mm (3.1 " x 2.7")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.18kg",
            "product_variants": "3210-01 - 3210 Manual & Auto Start Control Module (Mpu)"
        }
    },

    {
        "id": 5,
        "image": "../assets/images/deepsea/dse4210.webp",
        "heading": "DSE4210",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE4210 is an Auto Start Control Module that has been developed to provide an outstanding range of features within a compact module size.",
        "features": {
            "overall_size": "140 mm x 113 mm x 43 mm (5.5” x 4.4” x 1.7”) ",
            "panel_cutout_size": '118 mm x 92 mm (4.6" x 3.6") ',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.22kg",
            "product_variants": "4210-01 - 4210 Auto Start Control Module"
        }
    },

    {
        "id": 6,
        "image": "../assets/images/deepsea/dse4510mkii.webp",
        "heading": "DSE4510 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE4510 is a compact Auto Start Control Module that has been developed to provide an outstanding range of features within a compact enclosure.",
        "features": {
            "overall_size": "140 mm x 113 mm x 43 mm (5.5” x 4.4” x 1.5”)",
            "panel_cutout_size": '118 mm x 92 mm (4.6" x 3.6")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.26kg",
            "product_variants": "4510-03 - 4510 Auto Start Control Module (Ct, Rtc), 4510-04 - 4510 Auto Start Control Module (Ct, Rtc, Htr)"
        }
    },

    {
        "id": 7,
        "image": "../assets/images/deepsea/dse6010.webp",
        "heading": "DSE6010 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE 6010 MKII is an Auto Start Control Module developed to provide a wide range of operating and monitoring features for single diesel and gas gen-sets. ",
        "features": {
            "overall_size": "216 mm x 158 mm x 43 mm (8.5” x 6.2” x 1.5”)",
            "panel_cutout_size": '184 mm x 137 mm (7.2" x 5.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.48kg",
            "product_variants": "6010-03 - 6010 MKII Auto Start Control Module"
        }
    },

    {
        "id": 8,
        "image": "../assets/images/deepsea/dse6110.webp",
        "heading": "DSE6110 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE 6110 MKII is an Auto Start Control Module developed to provide a wide range of operating and monitoring features for single diesel and gas gen-sets. ",
        "features": {
            "overall_size": "216 mm x 158 mm x 43 mm (8.5” x 6.2” x 1.5”)",
            "panel_cutout_size": "184 mm x 137 mm (7.2” x 5.3”)",
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.5kg",
            "product_variants": "6110-03 - 6110 MKII Auto Start Control Module"
        }
    },

    {
        "id": 9,
        "image": "../assets/images/deepsea/dse7110mkii.webp",
        "heading": "DSE7110 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE7110 MKII is an Auto Start Control Module with an icon-based display. The control module has been designed to control single diesel or gas gen-set applications. ",
        "features": {
            "overall_size": "240 mm x 181 mm x 42 mm (9.4” x 6.8” x 1.6”) ",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.82kg",
            "product_variants": "7110-01 - 7110 MKII Auto Start Control Module"
        }
    },

    {
        "id": 10,
        "image": "../assets/images/deepsea/dse7310mkii.webp",
        "heading": "DSE7310 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE7310 MKII is a powerful, new generation auto start genset control module with a highly sophisticated level of new features and functions, presented in the usual DSE user-friendly format. Suitable for a wide variety of single, diesel or gas Gen-set applications. ",
        "features": {
            "overall_size": '245 mm x 184 mm x 51 mm (9.6" x 7.2" x 2.0")',
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": '8.0 mm (0.3")',
            "weight":"N/A",
            "product_variants": "7310-03 - 7310 MKII Autostart Control Module"
        }
    },

    {
        "id": 11,
        "image": "../assets/images/deepsea/dse7410mkii.webp",
        "heading": "DSE7410 MKII",      
        "sub_heading": "Auto Start Control Module",
        "paragraph": "The DSE7410 MKII is an intelligent, powerful auto start control module with high-level features and functionality. The control module is the first module in the DSE range to include in-built SNMP and features an embedded web server. The module is suitable for a wide range of single-set gas and diesel applications.",
        "features": {
            "overall_size": "245 mm x 184 mm x 51 mm (9.6” x 7.2” x 2.0”)",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.88kg",
            "product_variants": "7410-03 - 7410 MKII Auto Start Control Module"
        }
    }],

};

const FCModules = {
'Title': 'AUTO MAINS (UTILITY) FAILURE CONTROL MODULES',
'Products':[{
        "id": 1,
        "image": "../assets/images/deepsea/dse4220.webp",
        "heading": "DSE4220",
        "sub_heading": "Auto Mains (Utility) Control Module",      
        "paragraph": "The DSE4220 is an Auto Mains (Utility) Failure Control Module that has been       developed to provide an outstanding range of features within a compact module size. ",
        "features": {
            "overall_size": "140 mm x 113 mm x 43 mm (5.5” x 4.4” x 1.7”)",
            "panel_cutout_size": '118 mm x 92 mm (4.6" x 3.6")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.24kg",
            "product_variants": "4220-01 - 4220 Auto Mains (Utility) Failure Control Module"
        }
 },

 {
    "id": 2,
    "image": "../assets/images/deepsea/dse4520.webp",
    "heading": "DSE4520 MKII",
    "sub_heading": "Auto Mains (Utility) Control Module",
    "paragraph": "The DSE4520 MKII is a compact Auto Mains (Utility) Failure Control Module that has been developed to provide an outstanding range of features within a compact enclosure. New Features Added May 2020. Read Product Change Notification Document for details.",
    "features": {
            "overall_size": "140 mm x 113 mm x 43 mm (5.5” x 4.4” x 1.5”)",
            "panel_cutout_size": '118 mm x 92 mm (4.6" x 3.6")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.26kg",
            "product_variants": "4520-05 - 4520 Auto Mains (Utility) Failure Control Module (Ct, Rtc),4520-06 - 4520 Auto Mains (Utility) Failure Control Module (Ct, Rtc, Htr)"
    }
},

{
    "id": 3,
    "image": "../assets/images/deepsea/dse6020.webp",
    "heading": "DSE6020 MKII",
    "sub_heading": "Auto Mains (Utility) Control Module",
    "paragraph": "The DSE 6020 MKII is an Auto Mains (Utility) Failure Control Module developed to provide a wide range of operating and monitoring features for single diesel and gas gen-sets. ",
    "features": {
            "overall_size": "216 mm x 158 mm x 43 mm (8.5” x 6.2” x 1.5”)",
            "panel_cutout_size": '184 mm x 137 mm (7.2" x 5.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.48kg",
            "product_variants": "6020-03 - MKII Auto Mains (Utility) Failure Control Module, 6020-04 - MKII Auto Mains (Utility) Failure Control Module (Htr)"
    }
},

{
    "id": 4,
    "image": "../assets/images/deepsea/dse6120.webp",
    "heading": "DSE6120 MKII",
    "sub_heading": "Auto Mains (Utility) Failure Control Module",
    "paragraph": "The DSE 6120 MKII is an Auto Mains (Utility) Failure Control Module developed to provide a wide range of operating and monitoring features for single diesel and gas gen-sets. ",
    "features": {
            "overall_size": "216 mm x 158 mm x 43 mm (8.5” x 6.2” x 1.5”)",
            "panel_cutout_size": "184 mm x 137 mm (7.2” x 5.3”)",
            "maximum_panel_thickness": "8.0mm (0.3”)",
            "weight":"0.5kg",
            "product_variants": "6120-03 - 6120 MKII Auto Mains (Utility) Failure Control Module"
    }
},

{
    "id": 5,
    "image": "../assets/images/deepsea/dse7120.webp",
    "heading": "DSE7120 MKII",
    "sub_heading": "Auto Mains (Utility) Failure Control Module",
    "paragraph": "The DSE7120 is an Auto Mains (Utility) Failure Control Module with an icon-based display. The control module has been designed to control single diesel or gas gen-set applications. ",
    "features": {
            "overall_size": "240 mm x 181 mm x 42 mm (9.4” x 6.8” x 1.6”)",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.82kg",
            "product_variants": "7120-01 - 7120 MKII Auto Mains (Utility) Control Module"
    }
},

{
    "id": 6,
    "image": "../assets/images/deepsea/dse7320.webp",
    "heading": "DSE7320 MKII",
    "sub_heading": "Auto Mains (Utility) Failure Control Module",
    "paragraph": "The DSE7320 MKII is a powerful, new generation Auto Mains (Utility) Failure genset control module with a highly sophisticated level of new features and functions, presented in the usual DSE user-friendly format. Suitable for a wide variety of single, diesel or gas Gen-set applications. ",
    "features": {
            "overall_size": '245 mm x 184 mm x 51 mm (9.6" x 7.2" x 2.0")',
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": '8.0 mm (0.3")',
             "weight":"N/A",
            "product_variants": "7320-03 - 7320 MKII Auto Mains (Utility) Failure Control Module"
    }
},

{
    "id": 7,
    "image": "../assets/images/deepsea/dse7420mkii.webp",
    "heading": "DSE7420 MKII",
    "sub_heading": "Auto Mains (Utility) Failure Control Module",
    "paragraph": "The DSE7420 MKII is an intelligent, powerful auto mains (utility) failure control module with high-level features and functionality. The control module is the first module in the DSE range to include in-built SNMP and features an embedded web server. The module is suitable for a wide range of single-set gas and diesel applications. ",
    "features": {
            "overall_size": "245 mm x 184 mm x 51 mm (9.6” x 7.2” x 2.0”) ",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.88kg",
            "product_variants": "7420-03 - 7420 MKII Auto Mains (Utility) Failure Control Module, 7420-04 - 7420 MKII Auto Mains (Utility) Failure Control Module (Htr)"
    }
}],

};

const SharingModules = {
'Title': 'SYNCHRONISING AND LOAD SHARING CONTROL MODULES',
'Products': [{
        "id": 1,
        "image": "../assets/images/deepsea/dse8610mkii.webp",
        "heading": "DSE8610 MKII",      
        "sub_heading": "Synchronising & Load Sharing Auto Start Control Module",
        "paragraph": "The DSE8610 MKII represents the latest in complex load sharing & synchronising control technology. Designed to handle the most complex grid type generator applications the DSE8610 MKII control module is packed with multiple features and benefits that are unrivalled across the generator control industry. ",
        "features": {
            "overall_size": '245 mm x 184 mm x 51 mm (9.6" x 7.2" x 2.0")',
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": '8.0 mm (0.3")',
            "weight":"0.88kg",
            "product_variants": "8610-02 - 8610 MKII Synchronising & Load Sharing Control Module (Ct, Rtc)"
        }
    },

    {
        "id": 2,
        "image": "../assets/images/deepsea/dse8620.webp",
        "heading": "DSE8620",      
        "sub_heading": "Synchronising & Load Sharing Auto Mains (Utility) Failure Control Module",
        "paragraph": "The DSE8620 is an intelligent mono display auto mains (utility) failure load share control module packed with industry leading features to enhance paralleling single gensets with a mains (utility) supply. ",
        "features": {
            "overall_size": "240 mm x 181 mm x 42 mm (9.4” x 6.8” x 1.6”)",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.88kg",
            "product_variants": "8620-01 - 8620 Auto Mains (Utility) Failure Control Module "
        }
    },

    {
        "id": 3,
        "image": "../assets/images/deepsea/dse8660.webp",
        "heading": "DSE8660 MKII",      
        "sub_heading": "Auto Transfer Switch & Mains (Utility) Control Module",
        "paragraph": "The DSE8660 MKII is the latest and most advanced Auto Transfer Switch & Mains (Utility) Control Module within the DSE synchronising and load sharing control module range. Developed alongside the DSE8610 MKII this control module provides industry-leading features and benefits for the most complex grid type generator installations.",
        "features": {
            "overall_size": '245 mm x 184 mm x 51 mm (9.6" x 7.2" x 2.0")',
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": '8.0 mm (0.3")',
            "weight":"0.88kg",
            "product_variants": "8660-02 - 8660 MKII Auto Transfer Switch & Mains (Utility) Control Module (Ct, Rtc)"
        }
    },

    {
        "id": 4,
        "image": "../assets/images/deepsea/dse8661.webp",
        "heading": "DSE8661",      
        "sub_heading": "Two-Part Auto Transfer Switch & Mains (Utility) Control Module",
        "paragraph": "The DSE8661 is an intelligent two-part mono display single or multi-mains (utility) controller with automatic transfer switch capabilities. The DSE8661 can be used with remote breakers up to 1.2km apart.  The modules synchronise single or multiple set systems in conjunction with DSE synchronising & load share control modules.",
        "features": {
            "overall_size": "240 mm x 181 mm x 42 mm (9.4” x 6.8” x 1.6”)",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.88kg",
            "product_variants": "8661-01 - 8661 Two-Part Auto Transfer Switch & Mains (Utility) Control Module"
        }
    },

    {
        "id": 5,
        "image": "../assets/images/deepsea/dse7320.webp",
        "heading": "DSE7320 MKII",      
        "sub_heading": "Auto Mains (Utility) Failure Control Module",
        "paragraph": "The DSE7320 MKII is a powerful, new generation Auto Mains (Utility) Failure genset control module with a highly sophisticated level of new features and functions, presented in the usual DSE user-friendly format. Suitable for a wide variety of single, diesel or gas Gen-set applications. ",
        "features": {
            "overall_size": '245 mm x 184 mm x 51 mm (9.6" x 7.2" x 2.0")',
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": '8.0 mm (0.3")',
            "weight":"N/A",
            "product_variants": "7320-03 - 7320 MKII Auto Mains (Utility) Failure Control Module"
        }
    },

    {
        "id": 6,
        "image": "../assets/images/deepsea/dse871060.webp",
        "heading": "DSE8710/60",      
        "sub_heading": "Mono Remote Displays",
        "paragraph": "ear Mounted Synchronising & Load Sharing Control Module The DSE8710 is an intelligent rear mounted auto start load share control module packed with industry leading features to enhance multi-set",
        "features": {
            "overall_size": "240 mm x 172 mm x 57 mm (9.4” x 6.8” x 2.2”)",
            "panel_cutout_size": "N/A",
            "maximum_panel_thickness": "N/A",
            "weight":"0.74kg",
            "product_variants": "8710-01 – 8710 Rear Mounted Synchronising & Load Sharing Control Module"
        }
    },

    {
        "id": 7,
        "image": "../assets/images/deepsea/dse8721.webp",
        "heading": "DSE8721",      
        "sub_heading": "Graphical Colour Remote Display",
        "paragraph": "The DSE8721 remote display has been expertly designed to provide the DSE8610/60, DSE8610/60 MKII Load Share Control Modules and DSE8710/60 Rear Mounted Load Share Control Modules flexible graphical colour display options",
        "features": {
            "overall_size": "310 mm x 160 mm x 40 mm (12.2” x 6.3” x 1.5”)",
            "panel_cutout_size": '282 mm x 136 mm (11.1" x 5.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"1.0kg",
            "product_variants": '8721 7" Graphical Colour Remote Display'
        }
    },

    {
        "id": 8,
        "image": "../assets/images/deepsea/dse8810.webp",
        "heading": "DSE8810",      
        "sub_heading": "Load Share Control with Graphical Colour Display",
        "paragraph": "The DSE8810 is an intelligent graphical colour display load share control module packed with industry leading features to enhance multi-set control. The module can be synchronised with up to 32 generators within the same system. ",
        "features": {
            "overall_size": "245 mm x 184 mm x 50 mm (9.6” x 7.2” x 2.0”) ",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.98kg",
            "product_variants": "8810-01 - 8810 Load Share Control Module with Graphical Colour Display"
        }
    },

    {
        "id": 9,
        "image": "../assets/images/deepsea/dse8860.webp",
        "heading": "DSE8860",      
        "sub_heading": "Auto Transfer Switch & Mains (Utility) Graphical Colour Display Control Module",
        "paragraph": "The DSE8860 is an intelligent graphical colour display single or multi-mains (utility) controller with automatic transfer switch capabilities. The control module synchronises single or multiple set systems in conjunction with DSE synchronising & load share control modules.",
        "features": {
            "overall_size": "245 mm x 184 mm x 50 mm (9.6” x 7.2” x 2.0”)",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.88kg",
            "product_variants": "8860-01 - 8860 Auto Transfer Switch & Mains (Utility) Graphical Colour Display Control Module"
        }
    },

    {
        "id": 10,
        "image": "../assets/images/deepsea/dse871116.webp",
        "heading": "DSE8711/8716",      
        "sub_heading": "Mono Remote Displays",
        "paragraph": "The DSE8711 and DSE8716 remote displays have been expertly designed to provide the DSE8710/60 Rear Mounted Load Share Control Modules flexible display options.",
        "features": {
            "overall_size": "240 mm x 181 mm x 42 mm (9.4” x 7.1” x 1.6”) ",
            "panel_cutout_size": '220 mm x 160 mm (8.7" x 6.3")',
            "maximum_panel_thickness": "8.0 mm (0.3”)",
            "weight":"0.76kg",
            "product_variants": "8711-01 - 8711 Mono Remote Display (For use with 8710), 8716-01 - 8716 Mono Remote Display (For use with 8760)"
        }
    }],
};

const LubiSmps = {
    'Title': 'Switching Power Supplies',
    'Products': 
    [{
        "id": 1,
        "heading": "LESA15P5",
        "image": "../assets/images/lubi/smps15p5.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA15P5",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 2,
        "heading": "LESA15B5",
        "image": "../assets/images/lubi/smps15b5.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA15B5",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 3,
        "heading": "LESC25P5",
        "image": "../assets/images/lubi/smps25p5.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESC25P5",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 4,
        "heading": "LESC25B5",
        "image": "../assets/images/lubi/lesc25b5.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESC25B5",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 5,
        "heading": "LESA50P5",
        "image": "../assets/images/lubi/lesa50p5.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA50P5",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 6,
        "heading": "LESA12P12",
        "image": "../assets/images/lubi/lesa12p12.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA12P12",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 7,
        "heading": "LESA15P12",
        "image": "../assets/images/lubi/lesa15p12.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA15P12",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 8,
        "heading": "LESA12B12",
        "image": "../assets/images/lubi/lesa12b12.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA12B12",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 9,
        "heading": "LESA15B12",
        "image": "../assets/images/lubi/lesa15b12.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA15B12",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    },

    {
        "id": 10,
        "heading": "LESA35P12",
        "image": "../assets/images/lubi/lesa35p12.webp",      
        "features": {
            "products_name":"SMPS", 
            "model_number":"LESA35P12",
            "manufacturer":"Lubi",
            "description":"I/P-100~264VAC, O/P-5V/3A, PANEL MOUNT"
        },
        "sub_heading": "Technical Specifications",
        "specifications": {
            "number_of_outputs":"Single",
            "mounting_type":"Panel",
            "output_power":"15W",
            "output_voltage":"5v",
            "output_current":"3A"

        }
    }],

};

const LTTape = {
    'Title': 'L.T.Tape Insulated',
    'Products': [{
        "id": 1,
        "image": "../assets/images/ampturn/lttape1.webp",
        "bottom_desc": "TAPE RING TYPE"
        },
        {
            "id": 2,
            "image": "../assets/images/ampturn/lttape2.webp",
            "bottom_desc": "TAPE RECTANGULAR TYPE"
        },
        {
            "id": 3,
            "image": "../assets/images/ampturn/lttape33.webp",
            "bottom_desc": "TAPE INSULATED WPL TYPE"
            },
        {
            "id": 4,
            "image": "../assets/images/ampturn/lttape4.webp",
            "bottom_desc": "TAPE WOUND PRIMARY TYPE"
            }],
    'SpecTitle': 'LV Current Transformers',
    "Specifications":[
        {            
        "label": "Service",
        "value": "Indoor purpose"
        },
        {
        "label": "System Voltage", 
        "value" : "Upto 1.1kV",
        },
        {
        "label": "Application",
        "value": "Suitable For Metering &amp; Relaying application in AC Power Systems."
        },
        {
        "label": "Frequency", 
        "value" : "50Hz To 400Hz",
        },
        {
        "label": "Primary Current",
        "value" : "1A To 75,000A"
        },
        {
        "label": "Secondary Current", 
        "value" : "1A, 5A, 0.577A",
        },
        {
        "label": "Burden (VA)",
        "value" : "1, 1.25, 1.5, 2.5, 3.75, 5, 7.5, 10, 12.5, 15, 20VA"
        },
        {
        "label": "Accuracy Class", 
        "value" : "Metering: 0.2, 0.2s, 0.5, 0.5s, 1, 3 &amp; 5",
        },
        {
        "label": "Protection",
        "value" : "5P10, 5P20, 10P10, 10P20"
        },
        {
        "label": "Special Protection (PS)", 
        "value" : "Knee Point Voltage(Vk) &amp; Magnetizing Current (Im) as Per Requirement",
        },
        {
        "label": "Ambient Temperature",
        "value" : "- 50 C to + 450 C"
        },
        {
        "label": "Thermal Short Circuit Current (Ith)", 
        "value" : "60 x Ip / 1 Sec",
        },
        {
        "label": "Instrument Security Factor (ISF)",
        "value" : "2.5, 5, 10"
        },
        {
        "label": "Thermal Insulation Class", 
        "value" : "Class A, Class B &amp;Class F",
        },
        {
        "label": "Type / Encapsulation",
        "value" : "Resin Cast, Moulded Case &amp; Tape Insulated"
        },
        {
        "label": "Construction", 
        "value" : "Window type (Ring &amp; Rectangular), Wound Primary Type &amp; Bar Primary Type",
        }, 
        {    
        "label" : "Applicable Standard", 
        "value" : "IS 2705 Part (1, 2 &amp; 3), IEC 61869 Part (1 &amp; 2)"
    }]
};

const LTMoulded = {
    'Title': 'L.T.Moulded Case',
    'CategoryImage': '../assets/images/ampturn/ltm1.webp',
    'Products': [{
        "id": 1,
        "image": "../assets/images/ampturn/ltm1.webp",
        "bottom_desc": "MOULDED CASE RING TYPE"      
        },
        {
        "id": 2,
        "image": "../assets/images/ampturn/ltm22.webp",
        "bottom_desc": "MOULDED CASE RECTANGULAR TYPE"
        },
        {
        "id": 3,
        "image": "../assets/images/ampturn/ltm3.webp",
        "bottom_desc": "MOULDED CASE WOUND PRIMARY TYPE"
        },
        {
        "id": 4,
        "image": "../assets/images/ampturn/ltm4.webp",
        "bottom_desc": "MOULDED CASE RECTANGULAR TYPE"
        },
        {
        "id": 5,
        "image": "../assets/images/ampturn/ltm5.webp",
        "bottom_desc": "MOULDED CASE RECTANGULAR TYPE"
        }],
    'SpecTitle': 'LV Current Transformers',
    "Specifications":[
        {
        "label": "Service",
        "value": "Indoor purpose"
        },
        {
        "label": "System Voltage", 
        "value" : "Upto 1.1kV",
        },
        {
        "label": "Application",
        "value": "Suitable For Metering &amp; Relaying application in AC Power Systems."
        },
        {
        "label": "Frequency", 
        "value" : "50Hz To 400Hz",
        },
        {
        "label": "Primary Current",
        "value" : "1A To 75,000A"
        },
        {
        "label": "Secondary Current", 
        "value" : "1A, 5A, 0.577A",
        },
        {
        "label": "Burden (VA)",
        "value" : "1, 1.25, 1.5, 2.5, 3.75, 5, 7.5, 10, 12.5, 15, 20VA"
        },
        {
        "label": "Accuracy Class", 
        "value" : "Metering: 0.2, 0.2s, 0.5, 0.5s, 1, 3 &amp; 5",
        },
        {
        "label": "Protection",
        "value" : "5P10, 5P20, 10P10, 10P20"
        },
        {
        "label": "Special Protection (PS)", 
        "value" : "Knee Point Voltage(Vk) &amp; Magnetizing Current (Im) as Per Requirement",
        },
        {
        "label": "Ambient Temperature",
        "value" : "- 50 C to + 450 C"
        },
        {
        "label": "Thermal Short Circuit Current (Ith)", 
        "value" : "60 x Ip / 1 Sec",
        },
        {
        "label": "Instrument Security Factor (ISF)",
        "value" : "2.5, 5, 10"
        },
        {
        "label": "Thermal Insulation Class", 
        "value" : "Class A, Class B &amp;Class F",
        },
        {
        "label": "Type / Encapsulation",
        "value" : "Resin Cast, Moulded Case &amp; Tape Insulated"
        },
        {
        "label": "Construction", 
        "value" : "Window type (Ring &amp; Rectangular), Wound Primary Type &amp; Bar Primary Type",
        }, 
        {    
        "label" : "Applicable Standard", 
        "value" : "IS 2705 Part (1, 2 &amp; 3), IEC 61869 Part (1 &amp; 2)"
        }]
};

const LTResin = {
    'Title': 'L.T.Resin Cast',
    'Products': [{
        "id": 1,
        "image": "../assets/images/ampturn/resincast1.webp",
        "bottom_desc": "RESIN CAST RECTANGULAR TYPE"      
        },
        {
        "id": 2,
        "image": "../assets/images/ampturn/resincast2.webp",
        "bottom_desc": "RESIN CAST RECTANGULAR TYPE"
        },
        {
        "id": 3,
        "image": "../assets/images/ampturn/resincast33.webp",
        "bottom_desc": "RESIN CAST RECTANGULAR TYPE"
        },
        {
        "id": 4,
        "image": "../assets/images/ampturn/resincast4.webp",
        "bottom_desc": "RESIN CAST RING TYPE"
        },
        {
        "id": 5,
        "image": "../assets/images/ampturn/resincast5.webp",
        "bottom_desc": "RESIN CAST RING TYPE"
        },
        {
        "id": 6,
        "image": "../assets/images/ampturn/resincast6.webp",
        "bottom_desc": "RESIN CAST WPL TYPE"
        },
        {
        "id": 7,
        "image": "../assets/images/ampturn/resincast7.webp",
        "bottom_desc": "RESIN CAST WOUND PRIMARY TYPE"
        }],
    'SpecTitle': 'LV Current Transformers',
    "Specifications":[
        {
        "label": "Service",
        "value": "Indoor purpose"
        },
        {
        "label": "System Voltage", 
        "value" : "Upto 1.1kV",
        },
        {
        "label": "Application",
        "value": "Suitable For Metering &amp; Relaying application in AC Power Systems."
        },
        {
        "label": "Frequency", 
        "value" : "50Hz To 400Hz",
        },
        {
        "label": "Primary Current",
        "value" : "1A To 75,000A"
        },
        {
        "label": "Secondary Current", 
        "value" : "1A, 5A, 0.577A",
        },
        {
        "label": "Burden (VA)",
        "value" : "1, 1.25, 1.5, 2.5, 3.75, 5, 7.5, 10, 12.5, 15, 20VA"
        },
        {
        "label": "Accuracy Class", 
        "value" : "Metering: 0.2, 0.2s, 0.5, 0.5s, 1, 3 &amp; 5",
        },
        {
        "label": "Protection",
        "value" : "5P10, 5P20, 10P10, 10P20"
        },
        {
        "label": "Special Protection (PS)", 
        "value" : "Knee Point Voltage(Vk) &amp; Magnetizing Current (Im) as Per Requirement",
        },
        {
        "label": "Ambient Temperature",
        "value" : "- 50 C to + 450 C"
        },
        {
        "label": "Thermal Short Circuit Current (Ith)", 
        "value" : "60 x Ip / 1 Sec",
        },
        {
        "label": "Instrument Security Factor (ISF)",
        "value" : "2.5, 5, 10"
        },
        {
        "label": "Thermal Insulation Class", 
        "value" : "Class A, Class B &amp;Class F",
        },
        {
        "label": "Type / Encapsulation",
        "value" : "Resin Cast, Moulded Case &amp; Tape Insulated"
        },
        {
        "label": "Construction", 
        "value" : "Window type (Ring &amp; Rectangular), Wound Primary Type &amp; Bar Primary Type",
        }, 
        {    
        "label" : "Applicable Standard", 
        "value" : "IS 2705 Part (1, 2 &amp; 3), IEC 61869 Part (1 &amp; 2)"
        }]
};

const Seco = {
    'Title': 'Seco Products',
    'Products': [{
        "id": 1,
        "heading": "Hooter",
        "image": '../assets/images/seco/hooter.webp',
        "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
      },
      {
        "id": 2,
        "heading": "Buzzer",
        "image": '../assets/images/seco/buzzer.webp',
        "paragraph": "We design and manufacture Electronic Buzzers with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound. (any one tone can be selectable through link ) Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
      },
      {
        "id": 3,
        "heading": "Microcontroller Annunciators",
        "image": '../assets/images/seco/annunciator1.webp',
        "paragraph": "We design & manufacture Microcontroller based Annunciator from 2 windows to 64 windows with both Big window unit and small window unit & combination of Big & small window units in moulded box with Wide Aux. supply range, Standby working with AC supply, site selectable window colour, DC Fail Indication, Ac Fail Indication, RS 485 communication and Repeat relay contacts.",
      },
      {
        "id": 4,
        "heading": "Wireless Annunciator - Zigbee Based",
        "image": '../assets/images/seco/mmannounciator.webp',
        "paragraph": "We design and manufacture Wireless Annunciator with Microcontroller based advance technology and field proven model for all types of fields and environmental conditions. The purpose of this product is to give window Annunciation required at specific place and where the inputs or protective relays are at distance with the use of the radio frequency signal. This product can be used in the Power generation projects/ Power transmission projects/ process control or Industrial applications where we can’t run the wires to get the Annunciation for devices that may be in the hazardous environment and it also saves the copper wires.",
      },
      {
        "id": 5,
        "heading": "Annunciator - Input From PLC",
        "image": '../assets/images/seco/plcannounciator.webp',
        "paragraph": "We design and manufacture Alarm Annunciator – input form PLC (RS 485 input) with Microcontroller based advance technology. This type of Annunciation system is useful in process control panels/ PLC panels to eliminate control cable wires and accept input from Program logic controller by only twisted two wires on RS 485 (Modus protocol). It saves cable cost, labour and also solve loose contact issues. This unit increases the reliability of the system.",
      }],
};

const Leap = {
    'Title': 'Leap Industries',
    'Products': [{
            "id": 1,
            "heading": "LED Tube Light",
            "sub_heading": "LED Tube Light",
            "image": '../assets/images/leap/tubelight.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "No flicking and humming",
                "High efficiency and Constant voltage driver",
                "Special circuit design",
                
            ],
            "app_heading": "Available In:",
            "app_list": [
                "1 Ft- 6W",
                "2 Ft-10W",
                "4 Ft-20W",
                "4 Ft-22W",
                "4 Ft-30W",
                "4 Ft-36W",
                "4 Ft-40W",
            ],
            "features": {
            "tube_base_type":"T8",
            "length":"1 Foot, 2 Feet, 4 Feet",
            "ip_rating":"IP33",
            "power_consumption":"6 W - 10 W, 16 W - 20 W, 11 W - 15 W",
            "shape":"Round",
            "color":"White",
            

        }
        
        },
        {
            "id": 2,
            "heading": "LED Tube Light",
            "sub_heading": "1 Feet 5w to 10w Tube Light",
            "image": '../assets/images/leap/tubelight1.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "No flicking and humming",
                "High efficiency and Constant voltage driver",
                "Special circuit design",
            ],
            "app_heading": "Available In:",
            "app_list": [
                "1 Ft- 6 W",
                "2 Ft- 10 W",
                "4 Ft- 20 W",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "length":"1 Foot, 2 Foot, 4 Foot",
                "ip_rating":"IP33",
                "power_consumption":"6w - 10w, 11w-16w, 18w-22w",
                "shape":"Round",
                "color":"Cool White",

        }
        
        },
        {
            "id": 3,
            "heading": "LED Panel Light",
            "sub_heading": "Square LED Panel Light",
            "image": '../assets/images/leap/ledsquarepanel.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Scratch resistance property",
                "Free from flaws",
                "Optimal quality"
            ],
            "app_heading": "Available In:",
            "app_list": [
                "6 Watt",
                "12 Watt",
                "18 Watt",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "ip_rating":"IP33",
                "power_consumption":"6 Watt, att, 18 Watt, 5 W",
                "shape":"Square",
                "color":"Silver White",

        }
        
        },
        {
            "id": 4,
            "heading": "LED Panel Light",
            "sub_heading": "Round LED Panel Light",
            "image": '../assets/images/leap/ledroundpanellight.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Dimensional accuracy",
                "Low maintenance cost",
                "Long Service Life",
            ],
            "app_heading": "Available In:",
            "app_list": ["Monitor real-time system voltage and frequency ",
                "6 Watt",
                "12 Watt",
                "18 Watt",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "length":"N/A",
                "ip_rating":"IP33",
                "power_consumption":"12 W",
                "shape":"Round",
                "color":"White",

        }
        
        },
        {
            "id": 5,
            "heading": "Street Light",
            "sub_heading": "LED Street Light",
            "image": '../assets/images/leap/ledstreetlight.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Excellent illumination",
                "High energy saving",
                "Fast integration",
            ],
            "app_heading": "Available In:",
            "app_list": [
                "9 Watt",
                "12 Watt",
                "18 Watt",
                "20 Watt",
                "24 Watt",
                "30 Watt",
                "40 Watt",
                "48 Watt",
                "72 Watt",
                "80 Watt",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "length":"1 Foot, 2 Foot, 4 Foot",
                "ip_rating":"IP33",
                "power_consumption":"6w - 10w, 11w-16w, 18w-22w",
                "shape":"Round",
                "color":"Cool White",

        }
        
        },
        {
            "id": 6,
            "heading": "Street Light",
            "sub_heading": "Solar Street Light",
            "image": '../assets/images/leap/solarstreetlight.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Excellent illumination",
                "High energy saving",
                "Fast integration",
            ],
            "app_heading": "Available In:",
            "app_list": [
                "12 Watt",
                "18 Watt",
                "24 Watt",
                "36 Watt",
                "48 Watt",
                "50 Watt",
                "72 Watt",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "length":"1 Foot, 2 Foot, 4 Foot",
                "ip_rating":"IP33",
                "power_consumption":"6w - 10w, 11w-16w, 18w-22w",
                "shape":"Round",
                "color":"Cool White",

        }
        
        },
        {
            "id": 7,
            "heading": "LED Driver",
            "image": '../assets/images/leap/leddriver.webp',
            "prod_id": "splitcorect",
            "features_heading": "Salient Features",
            "salient_features": [
                "Accurate dimensions",
                "Longer service life",
                "Efficient working",
            ],
            "app_heading": "Available In:",
            "app_list": ["Monitor real-time system voltage and frequency ",
                " Monitor source healthiness and output for both Source",
                " Wide range of motor operating voltage from 150VAC – 285V AC",
                " Automatic transfer switch for commercial centers, manufacturing, medical facilities,and data centers.",
            ],
            "features": {
                "tube_base_type":"T8 and T5",
                "length":"1 Foot, 2 Foot, 4 Foot",
                "ip_rating":"IP33",
                "power_consumption":"6w - 10w, 11w-16w, 18w-22w",
                "shape":"Round",
                "color":"Cool White",

        }
        
        }],
};

const Kalaivani = {
    'Title': 'Kalaivani Electricals',
    'Products': [{
        "id": 1,
        "heading": "OUTDOOR OIL COOLED CT",
        "image": '../assets/images/kalaivani/11KV_outdoor_oil_cooled_CT.webp',
        "paragraph": "Oil cooled transformers are made for use on various systems ranging from 11kv to 33kv. the basic construction of the CT is similar to CT of all voltage classes in that the core is placed in a tank mounted on top of the bushing and adequate paper insulation is provided on it. The secondary leads are run through the bushing to the secondary terminal box placed at the bottom of the bushing. The advantage of this type of construction is that the transformer is dynamically more stable under short circuit conditions, the various forces on the primary conductors tending to balance on another.",
        
         },
         {
        "id": 2,
        "heading": "OUTDOOR OIL COOLED PT",
        "image": '../assets/images/kalaivani/outpt.webp',
        "paragraph": "Potential Transformers are used for measurement and protective application, together with equipment such as meters and relays. Their role in electrical system is of primary importance as they are means of stepping down the voltage of a system to measurable values, such as 110V in the case of a potential transformer. This offers the advantage that measurement and protective equipment can be standardized on a few values of voltages.",
            },
        {
        "id": 3,
        "heading": "RESIN CAST CT & PT",
        "image": '../assets/images/kalaivani/ctpt.webp',
        "paragraph": "The transformers are vacuum encapsulated in epoxy resin, which ensures faultless insulation. Incombustible high-class raw material.",
            }],
};
// const Rishab = {
//     'Title': 'Rishabh Instruments',
//     'Products': [{
//         "id": 1,
//         "heading": "Handheld Digital Multimeters",
//         "image": '../assets/images/rishab/hdmulti.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       },
//       {
//         "id": 2,
//         "heading": "Digital and Analog Insulation Tester",
//         "image": '../assets/images/rishab/insulationtester.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       },
//       {
//         "id": 3,
//         "heading": "Digital Clamp Meters",
//         "image": '../assets/images/rishab/dclamp1.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       },
//       {
//         "id": 4,
//         "heading": "Insulation And Earth Tester",
//         "image": '../assets/images/rishab/dainsulationt.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       },
//       {
//         "id": 5,
//         "heading": "Analog Panel Meters",
//         "image": '../assets/images/rishab/analogpanel.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       },
//     //   {
//     //     "id": 6,
//     //     "heading": "Digital Panel Meters",
//     //     "image": '../assets/images/rishab/digitlpanel.webp',
//     //     "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//     //   },
//       {
//         "id": 6,
//         "heading": "Shunts",
//         "image": '../assets/images/rishab/shunts.webp',
//         "paragraph": "We design and manufacture Electronic Hooter with universal input supply of 20 to 275V DC & 65 to 275V AC. Site selectable three tones with a sound output of Intermittent, Continuous and bell sound.(Any one tone can be selectable through link). Output sound is more than 90 dB. Low depth of 45 mm moulded Box with Suitable clamps are provided for surface mounting and projection mounting.",
//       }],
// };




export { SmartMonitor, SmartControl, SmartResource, SmartNetwork, Eaton, SCModules, FCModules, SharingModules, LubiSmps, LTTape, LTMoulded, LTResin, Seco, Leap, Kalaivani, Eatonmcb, Eatonacb, Eatoncontactor  };